// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media not (min-width:658px){body[data-is-support-mobile-view=true] .BvYmH5rnMskl7Rhw4L_0.aOl8fI1JQRQYalMA3szB{padding:0 4px 0 8px}}.BvYmH5rnMskl7Rhw4L_0{cursor:pointer;align-items:center;width:100%;padding:0 4px;display:flex;position:relative}.BvYmH5rnMskl7Rhw4L_0.aOl8fI1JQRQYalMA3szB{padding:0 46px 0 4px}.o9TYoPnHd48TDLwvnZnb{cursor:default}.TQqYJG6_VHc12FGD0vVI{color:var(--content-primary-tertiary);width:39px;margin-right:16px;font-size:13px}.Br39zdAS5kJvaxDZOJwo{flex:1;min-width:100px;height:24px}.Br39zdAS5kJvaxDZOJwo label,.Br39zdAS5kJvaxDZOJwo input{width:100%;height:100%;line-height:24px}.fVYAVPYJTnwhMm53aucd{flex-wrap:wrap;gap:6px;width:100%;display:flex}.WhXbPZFsNwAU07WJFDJU{align-items:center;width:24px;height:24px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `BvYmH5rnMskl7Rhw4L_0`,
	"isCollapse": `aOl8fI1JQRQYalMA3szB`,
	"wrap--readOnly": `o9TYoPnHd48TDLwvnZnb`,
	"wrapReadOnly": `o9TYoPnHd48TDLwvnZnb`,
	"label": `TQqYJG6_VHc12FGD0vVI`,
	"input": `Br39zdAS5kJvaxDZOJwo`,
	"items": `fVYAVPYJTnwhMm53aucd`,
	"loader": `WhXbPZFsNwAU07WJFDJU`
};
export default ___CSS_LOADER_EXPORT___;
